import { render, staticRenderFns } from "./extraResourceHandles.vue?vue&type=template&id=570d0c9a&scoped=true&"
import script from "./extraResourceHandles.vue?vue&type=script&lang=js&"
export * from "./extraResourceHandles.vue?vue&type=script&lang=js&"
import style0 from "./extraResourceHandles.vue?vue&type=style&index=0&id=570d0c9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d0c9a",
  null
  
)

component.options.__file = "extraResourceHandles.vue"
export default component.exports